import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * AttachedFilesPanel — 附件展示面板
 *
 * 以卡片式展示用户在对话中上传的附件文件，视觉风格与 ToolCallPanel 对齐：
 *   - 收起状态：文件图标 + 文件名 + 文件大小 + 状态标签
 *   - 展开状态：文件元信息（MIME 类型、大小）
 *
 * 用于 CrashClawChatPanel 中渲染用户消息携带的附件。
 */
import { useState } from 'react';
import { PaperClipOutlined, FileOutlined, FileImageOutlined, FileTextOutlined, FileZipOutlined, RightOutlined, DownOutlined, } from '@ant-design/icons';
// @ts-ignore - SCSS module
import scss from './AiDrawer.scss';
import { ze } from 'utils/zhEn';
// ============================================================
// Helpers
// ============================================================
function formatFileSize(bytes) {
    if (!bytes || bytes <= 0)
        return '';
    if (bytes > 1024 * 1024) {
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    }
    return `${(bytes / 1024).toFixed(0)} KB`;
}
function getFileIcon(mimeType) {
    if (!mimeType)
        return _jsx(FileOutlined, {});
    if (mimeType.startsWith('image/'))
        return _jsx(FileImageOutlined, {});
    if (mimeType.startsWith('text/'))
        return _jsx(FileTextOutlined, {});
    if (mimeType.includes('zip') || mimeType.includes('compressed'))
        return _jsx(FileZipOutlined, {});
    return _jsx(FileOutlined, {});
}
// ============================================================
// Component
// ============================================================
const AttachedFilesPanel = ({ files }) => {
    const [expanded, setExpanded] = useState(false);
    const [hovered, setHovered] = useState(false);
    if (!files || files.length === 0)
        return null;
    const fileCount = files.length;
    const totalSize = files.reduce((sum, f) => sum + (f.size || 0), 0);
    const sizeStr = formatFileSize(totalSize);
    const headerClassName = [
        scss.clawToolCallHeader,
        expanded ? scss.clawToolCallHeaderExpanded : '',
    ].filter(Boolean).join(' ');
    return (_jsxs("div", { className: scss.clawToolCall, children: [_jsxs("div", { className: headerClassName, style: hovered ? { background: '#efeafb', borderColor: '#ddd6f3' } : undefined, onClick: () => setExpanded(!expanded), onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false), children: [_jsx(PaperClipOutlined, { className: scss.clawToolCallIcon }), _jsx("span", { className: scss.clawToolCallName, children: ze(`${fileCount} 个附件`, `${fileCount} file${fileCount > 1 ? 's' : ''}`) }), _jsx("span", { className: `${scss.clawToolCallStatus} ${scss.clawToolCallStatusDone}`, children: sizeStr || ze('已上传', 'Uploaded') }), _jsx("span", { className: scss.clawToolCallSubName, children: files.map((f) => f.name).join(', ') }), expanded
                        ? _jsx(DownOutlined, { className: scss.clawToolCallChevron })
                        : _jsx(RightOutlined, { className: scss.clawToolCallChevron })] }), expanded && (_jsx("div", { className: scss.clawToolCallBody, children: _jsxs("div", { className: scss.clawToolCallSection, children: [_jsx("div", { className: scss.clawToolCallSectionLabel, children: ze('文件列表', 'Files') }), files.map((f, idx) => (_jsxs("div", { style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                padding: '6px 10px',
                                background: '#f6f7fb',
                                border: '1px solid #eef0f5',
                                borderRadius: '6px',
                                marginBottom: idx < files.length - 1 ? '6px' : 0,
                                fontSize: '12px',
                            }, children: [_jsx("span", { style: { color: '#6669fe', fontSize: '14px', flexShrink: 0 }, children: getFileIcon(f.mimeType) }), _jsx("span", { style: { fontWeight: 500, color: '#2f3046', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, children: f.name }), _jsx("span", { style: { flexShrink: 0, color: '#999', fontSize: '11px', marginLeft: 'auto' }, children: formatFileSize(f.size) })] }, idx)))] }) }))] }));
};
export default AttachedFilesPanel;
